// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosError } from 'axios';
import { ofType } from 'redux-observable';
import { asyncScheduler, Observable } from 'rxjs';
import { switchMap, throttleTime } from 'rxjs/operators';
import { ActionType, getType } from 'typesafe-actions';

import { createFavorites } from '../../apis/base';
import { createFavoritesActions } from '../actionCreators/createFavoritesActions';
import { RootAction } from '../rootActionCreator';

const outputActions = {
  success: createFavoritesActions.success,
  failure: createFavoritesActions.failure
};

type RequestActionTypes = ActionType<
  typeof createFavoritesActions.request
>;
type OutputActionTypes = ActionType<typeof outputActions>;

export const createFavoritesEpic = (
  action$: Observable<RootAction>
): Observable<OutputActionTypes> => {
  return action$.pipe(
    ofType(
      // action filter
      getType(createFavoritesActions.request)
    ),
    throttleTime(1000, asyncScheduler, { leading: true, trailing: false }),
    switchMap((action: RequestActionTypes) => {
      // prepare api params
      const { onlineCourseId, labId, success } = action.payload;
      // send api promise
      return createFavorites(onlineCourseId, labId)
        .then((response: any) => {
          success();
          return createFavoritesActions.success('');
        })
        .catch((error: AxiosError) => {
          // handle error case here
          return createFavoritesActions.failure({ error });
        })
    })
  );
};
